import { fetchAndParse, jsonHeaders } from '#lib/helpers/fetch.js';
import { useAuthMutation } from '#lib/hooks/use-mutation.js';

async function postTranslate(body, authHeaders) {
    return await fetchAndParse(`${API_URL}/p/translate`, {
        method: 'POST',
        headers: { ...jsonHeaders, ...authHeaders },
        body: JSON.stringify(body)
    });
}

export default function useTranslation() {
    const translationMutation = useAuthMutation({
        mutationFn: postTranslate,
        mutationKey: ['translation'],
        onError: (err) => toast.error(err.message)
    });

    return { translationMutation };
}
